import { Box, Stack, Typography } from '@mui/material';
import {
  deviceChangeFieldLabels,
  formatDeviceChangeValue,
  formatHistoryTimestamp,
} from '@/features/operations/labels';
import type { DeviceChangeEntry } from '@/features/operations/types';
import { usePriceDisplay } from '@/features/operations/PriceDisplayProvider';

/// Prices are edited in any state, published included, so this is what explains why a phone
/// costs what it costs (BR-034).
export function DeviceChangeHistory({ entries }: { entries: DeviceChangeEntry[] }) {
  const { formatNullablePrice } = usePriceDisplay();
  if (!entries.length) {
    return null;
  }

  return (
    <Box>
      <Typography variant="overline" color="text.secondary">
        HISTORIAL DE CAMBIOS
      </Typography>
      <Stack component="ul" spacing={1} sx={{ listStyle: 'none', m: 0, p: 0, mt: 0.5 }}>
        {entries.map((entry) => {
          const label = deviceChangeFieldLabels[entry.field] || entry.field;
          const formatValue = (value: string | null) =>
            ['PAID_PRICE', 'SALE_PRICE'].includes(entry.field)
              ? formatNullablePrice(value === null ? null : Number(value))
              : formatDeviceChangeValue(entry.field, value);
          const newValue = formatValue(entry.newValue);

          return (
            <Stack component="li" key={entry.id} spacing={0.25}>
              <Typography variant="body2">
                {entry.oldValue === null
                  ? `${label}: ${newValue}`
                  : `${label}: ${formatValue(entry.oldValue)} → ${newValue}`}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {formatHistoryTimestamp(entry.createdAt)} ·{' '}
                {entry.changedBy ? entry.changedBy.fullName : 'Usuario eliminado'}
              </Typography>
            </Stack>
          );
        })}
      </Stack>
    </Box>
  );
}
